import { isEmptyObject } from '@sky-it-livedata-libraries/livedata-commons';
import { DataCardDriverRanking } from '../types';

/**
 * typeguard for DataCardDriverRanking
 * @param DataCardDriverRanking object passed to transformer
 */
export const isValidDataCardDriverRanking = (obj: DataCardDriverRanking): boolean => Boolean(obj?.data?.getCardDriverRankingWidget && !isEmptyObject(obj.data.getCardDriverRankingWidget));
